import SSGJ from './themes/SSGJ.js'
import page2 from './themes/page2.js'
import WLTS from '@/api/themes/WLTS'
import ZYTS from '@/api/themes/ZYTS'
import SBTS from '@/api/themes/SBTS'
export default {
  SSGJ,
  page2,
  WLTS,
  ZYTS, SBTS, SSGJ
}